<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4">Workplace Preparation</heading>
      <vs-row>
        <!-- work experience Benefits -->
        <vs-col vs-xs="12" vs-lg="6" class="my-5 pr-10">
          <!-- The heading and intro sit outside the list so only the benefits are list
               items (WCAG SC 1.3.1, audit 11.2). -->
          <heading size="h2" style-size="h5">The Benefits of Work Experience</heading>
          <p class="my-4">Why should I bother working for no pay???<br />&nbsp;</p>
          <ul role="list">
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                To get a feel for the job or career and learn the realities of what it entails
                before spending time and money on tertiary education.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">Gain hands-on experience and independence.</div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                An employment opportunity. The employer may offer you some paid work should they
                have a position available and are happy with how you performed.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Learn new skills that can be added to your resume and portfolio.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Demonstrate how you can learn and contribute to the workplace environment and
                request a reference to add to your referee list.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">Demonstrate reliability in an adult environment.</div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Meet new people and build your network. Networking and communication are
                particularly important skills for future opportunities.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">Enhance scholarship opportunities.</div>
            </li>
          </ul>
        </vs-col>
        <!-- VJE Benefits -->
        <vs-col vs-xs="12" vs-lg="6" class="my-5 pr-10">
          <heading size="h2" style-size="h5">The Benefits of a Virtual Job Experience</heading>
          <p class="my-4">
            Remember, a work experience program may not be a job you definitely want to do in the
            future. It may be something that just interests you and you may wish to gain some skills
            and experience.
          </p>
          <ul role="list">
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                To gain experience in a job/career that you may not have been able to participate in
                due to lack of placements available.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Add your certificate of completion to your resume or portfolio. You may even like to
                add the project you worked on to your portfolio.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Be in a position to ask specific questions about that job or career that you may not
                have considered. This may give you a deeper understanding of the position.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Demonstrates your enthusiasm to learn about a specific career area.
              </div>
            </li>
            <li class="flex items-center bold" role="listitem">
              <i class="vs-icon notranslate icon-scale feather icon-check bold"></i>
              <div class="ml-2">
                Learn and understand relevant employability skills. These skills are valued by
                employees and transferable over multiple jobs and careers.
              </div>
            </li>
          </ul>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card>
      <heading size="h2" style-size="h5"
        >You now need to complete the following short workplace preparation modules:</heading
      >

      <div class="vx-row my-5">
        <div
          class="vx-col w-full sm:w-1/2 lg:w-1/3 2xl:w-1/4 mb-base"
          v-for="index in 7"
          :key="index"
        >
          <vx-card class="overlay-card overflow-hidden">
            <template slot="no-body">
              <img :src="$data.moduleImages[index]" alt="" class="responsive" />
              <div class="card-overlay flex flex-col justify-between">
                <h4 class="text-white mb-4">{{ moduleNames[index] }}</h4>
                <router-link
                  :aria-label="`complete ${moduleNames[index]} module`"
                  :class="`btn btn-${
                    modules[index] === false ? 'secondary white' : 'primary'
                  } btn-size-medium`"
                  :to="{ path: 'workplace-preparation/module/' + index }"
                  >{{ modules[index] === false ? 'Complete' : 'Edit' }} Module
                </router-link>
                <vs-chip color="primary" v-if="false">
                  <vs-avatar icon-pack="feather" icon="icon-check" />
                  <span>Completed</span>
                </vs-chip>
              </div>
            </template>
          </vx-card>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';

export default {
  data() {
    return {
      moduleNames: {
        1: 'Contacting an Employer',
        2: 'Personal Presentation',
        3: 'Employer expectations and your rights',
        4: 'Communication',
        5: 'WHS (Workplace Health and Safety)',
        6: 'Work Experience Checklist',
        7: 'Work Experience Questions',
      },
      moduleImages: {
        1: require('@/assets/images/workplace_preparation/contacting_employer.jpg'),
        2: require('@/assets/images/workplace_preparation/personal_presentation.jpg'),
        3: require('@/assets/images/workplace_preparation/expectations_rights.jpg'),
        4: require('@/assets/images/workplace_preparation/communication.jpg'),
        5: require('@/assets/images/workplace_preparation/health_safety.jpg'),
        6: require('@/assets/images/workplace_preparation/checklist.jpg'),
        7: require('@/assets/images/workplace_preparation/questions.jpg'),
      },
    };
  },
  computed: {
    modules() {
      return store.getters['authStudent/preworkWorkplacePreparationModules'];
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
  },
  mounted() {
    if (
      typeof this.settings['workplace_preparation'] !== 'undefined' &&
      this.settings['workplace_preparation'] == false
    ) {
      router.push('/student/dashboard');
    }
  },
};
</script>

<style lang="scss" scoped>
// The module titles are white text straight over a photo (WCAG SC 1.4.3 - measured 1:1
// where the photo is light). A dark scrim guarantees at least 5.7:1 whatever the image.
.overlay-card .card-overlay {
  background: rgba(0, 0, 0, 0.6);
}

.bold {
  font-weight: 700;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
